import React from 'react';

import Layout from '../components/layout';
import Slider from '../components/slider';
import { Box, Text, Stack, _hover, Flex } from '@chakra-ui/core';
import PageWrapper from '../components/page.wrapper';

import {
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaGithub,
    FaEnvelope,
    FaPhoneAlt,
    FaMapMarkerAlt,
    FaInstagram,
} from 'react-icons/fa';

const img = require('../images/innerbanner.jpg');
const imgNew = require('../images/carehome/medical-equipment.jpg');
const imgNew2 = require('../images/carehome/medical-equipment-1.jpg');



const MedicalEquipments = () => (
    <Layout>
        <Box className="sub-menu">
            <Box className="sub-banner" style={{ backgroundImage: `url(${img})` }} />
            <Box className="content-row">
				<h1>Medical Equipment</h1>
                <Flex align="center" className="flex-row">
                    <Box flex="1" p="4">
                        <Box as="img" src={imgNew} />
						<Box as="img" src={imgNew2} />
						 
                    </Box>

                    <Box flex="1" p="4" className="brief-para">
                        <p>
                          Medical Equipment: Provide entire range of medical equipment and physiotherapy equipment and tools on                           rent and sales<br/><br/>
                          Medicine Supply: Supply of Medicine in bulk at your Door step with huge discount by our associate                               partner vendor

                        </p> 
						 
                    </Box>
                </Flex>
            </Box>
        </Box>
    </Layout>
);

export default MedicalEquipments;